// extracted by mini-css-extract-plugin
export default {"position":"_4mJHacrjCXVWN7yVszZy1A=="};